import React from 'react';
const stats = [['500+', 'Allenatori di pallavolo'], ['6 + 5', 'Volumi e bonus'], ['4.9/5', 'Valutazione media'], ['In tutta Italia', 'Scelto dai professionisti']];
const notes = [['“Ho programmato l’intera stagione scolastica in una sola serata. Ora ogni lezione di pallavolo ha un obiettivo chiaro e i miei ragazzi non vedono l’ora di entrare in palestra.”', 'Marco R.', 'Allenatore Settore Giovanile'], ['“I miei atleti migliorano molto più velocemente ora che seguono finalmente una progressione logica delle competenze. Questo ha cambiato tutto.”', 'Coach Alessandro', 'Società Sportiva Dilettantistica'], ['“Non passo più ore su YouTube a caccia di attività. Apro PALLAVOLO PRONTA ed è tutto lì. Tutto. Pronto all’uso.”', 'Sara L.', 'Allenatrice Under 16']];
export function ProofSection() {
  return <section className="bg-[#09281d] px-5 pb-16" data-id="element-189">
      <div className="mx-auto max-w-6xl" data-id="element-190">
        <div className="grid grid-cols-2 border border-emerald-300/25 bg-[#10372a] sm:grid-cols-4" data-id="element-191">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-emerald-300/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-192">
              <p className="font-display text-4xl font-bold uppercase text-emerald-300 sm:text-5xl" data-id="element-193">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-194">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-195">
          {notes.map(([quote, name, role]) => <figure key={name} className="flex flex-col border border-emerald-950/10 bg-white p-6" data-id="element-196">
              <div className="mb-4 text-amber-500" aria-label="5 stelle su 5" data-id="element-197">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#09281d]" data-id="element-198">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-emerald-950/10 pt-4 text-sm font-bold text-[#09281d]" data-id="element-199">
                {name}
                <span className="ml-2 text-xs font-medium text-slate-600" data-id="element-200">
                  {role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}